// extracted by mini-css-extract-plugin
export var container = "_dc-0";
export var icon = "_dc-1";
export var text = "_dc-2";